import { Injectable } from '@angular/core';
import { BaseRepository } from '../Common/Data/base.repository';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import {
    AppealListReportRequest,
    BudgetRequest,
    BudgetVarianceReportingRequest,
    ValueRequest,
    MaarRequest,
    ProgressStatusRequest,
    PsrRequest,
    SiteRequest,
    SupportInstanceEscalationActivityReportRequest,
    UserAccessRequest,
    UserActivityRequest,
    UserCSRRequest,
    TaxSavingsRequest,
} from './reporting.models';
@Injectable()
export class ReportingService extends BaseRepository {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    private SERVICE_URL: string = '/api/Reporting/';

    async runPsrReport(psrRequest: PsrRequest, shouldZip: boolean): Promise<number> {
        return lastValueFrom(
            this.httpPost(`${this.SERVICE_URL}psr${shouldZip ? '/zip' : ''}`, psrRequest),
        ) as Promise<number>;
    }

    async runBudgetReport(budgetRequest: BudgetRequest): Promise<number> {
        return lastValueFrom(this.httpPost(`${this.SERVICE_URL}budget`, budgetRequest)) as Promise<number>;
    }

    async runBudgetVarianceReport(budgetVarianceRequest: BudgetVarianceReportingRequest): Promise<number> {
        return lastValueFrom(
            this.httpPost(`${this.SERVICE_URL}budgetvariance`, budgetVarianceRequest),
        ) as Promise<number>;
    }

    async runMaarReport(maarRequest: MaarRequest): Promise<number> {
        return lastValueFrom(this.httpPost(`${this.SERVICE_URL}maar`, maarRequest)) as Promise<number>;
    }

    async runProgressStatusExtract(pseRequest: ProgressStatusRequest): Promise<number> {
        return lastValueFrom(this.httpPost(`${this.SERVICE_URL}pse`, pseRequest)) as Promise<number>;
    }

    async runSiteReport(siteRequest: SiteRequest): Promise<number> {
        return lastValueFrom(this.httpPost(`${this.SERVICE_URL}site`, siteRequest)) as Promise<number>;
    }

    async runUserActivityReport(userActivityRequest: UserActivityRequest): Promise<number> {
        return lastValueFrom(this.httpPost(`${this.SERVICE_URL}usr`, userActivityRequest)) as Promise<number>;
    }

    async runUserAccessReport(userAccessRequest: UserAccessRequest): Promise<number> {
        return lastValueFrom(this.httpPost(`${this.SERVICE_URL}usrAccess`, userAccessRequest)) as Promise<number>;
    }

    async runUserCSRExtract(userCSRRequest: UserCSRRequest): Promise<number> {
        return lastValueFrom(this.httpPost(`${this.SERVICE_URL}usrCsr`, userCSRRequest)) as Promise<number>;
    }

    async runAppealListReport(request: AppealListReportRequest): Promise<number> {
        return lastValueFrom(this.httpPost(`${this.SERVICE_URL}appealList`, request)) as Promise<number>;
    }

    async runSupportInstanceEscalationActivityReport(
        request: SupportInstanceEscalationActivityReportRequest,
    ): Promise<number> {
        return await lastValueFrom(this.httpPost(`${this.SERVICE_URL}siear`, request));
    }

    async runInitialValueReport(valueRequest: ValueRequest): Promise<number> {
        return lastValueFrom(this.httpPost(`${this.SERVICE_URL}initialValue`, valueRequest)) as Promise<number>;
    }

    async runFinalValueReport(valueRequest: ValueRequest): Promise<number> {
        return lastValueFrom(this.httpPost(`${this.SERVICE_URL}finalValue`, valueRequest)) as Promise<number>;
    }

    async runARBValueReport(valueRequest: ValueRequest): Promise<number> {
        return lastValueFrom(this.httpPost(`${this.SERVICE_URL}arbValue`, valueRequest)) as Promise<number>;
    }

    async runARBCoverLetterReport(valueRequest: ValueRequest): Promise<number> {
        return lastValueFrom(this.httpPost(`${this.SERVICE_URL}arbcover`, valueRequest)) as Promise<number>;
    }

    async runTaxSavingsReport(taxSavingsRequest: TaxSavingsRequest): Promise<number> {
        return lastValueFrom(this.httpPost(`${this.SERVICE_URL}taxsavings`, taxSavingsRequest)) as Promise<number>;
    }
}
